import { Typography, styled } from '@mui/material';

import { WarrTheme } from 'theme/warrcloud';

export const TypographyStyled = styled(Typography)`
  color: ${WarrTheme.palette.primary.main};
  font-weight: bolder;
  &:hover {
    cursor: pointer;
  }
`;
